import React from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../assets/404 error not found.json';
import { Home, ArrowLeft, Search, Mail } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex flex-col items-center justify-center px-6 py-12">
      {/* Container */}
      <div className="max-w-4xl w-full text-center space-y-8 animate-in fade-in zoom-in duration-700">
        
        {/* Lottie Animation Wrapper */}
        <div className="w-full max-w-md mx-auto relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-rose-400 to-orange-400 rounded-full opacity-0 blur-3xl group-hover:opacity-20 transition-opacity duration-1000" />
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ height: 320, width: 320, pointerEvents: 'none' }}
          />
        </div>

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-4xl sm:text-6xl font-black text-gray-900 tracking-tighter">
            Lost in the <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-orange-600">Craft?</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-500 max-w-lg mx-auto leading-relaxed">
            The page you're searching for seems to have vanished like a master's secret. 
            Let's guide you back to the right path.
          </p>
        </div>

        {/* Dynamic Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <button
            onClick={() => navigate('/')}
            className="group flex items-center justify-center gap-2 px-8 py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all hover:scale-[1.02] active:scale-[0.98] shadow-xl shadow-gray-200"
          >
            <Home size={20} className="group-hover:-translate-y-0.5 transition-transform" />
            Back to Home
          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-gray-100 text-gray-700 rounded-2xl font-bold hover:bg-gray-50 hover:border-gray-200 transition-all active:scale-[0.98]"
          >
            <ArrowLeft size={20} />
            Previous Page
          </button>
        </div>

        {/* Quick Links / Help Section */}
        <div className="pt-12 border-t border-gray-100 grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div className="space-y-2">
            <h4 className="text-sm font-bold text-gray-400 uppercase tracking-widest">Explore</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/artisans')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">Find Artisans</button></li>
              <li><button onClick={() => navigate('/categories')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">Browse Categories</button></li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="text-sm font-bold text-gray-400 uppercase tracking-widest">Inspiration</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/feed')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">Craft Community</button></li>
              <li><button onClick={() => navigate('/how-it-works')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">How it Works</button></li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="text-sm font-bold text-gray-400 uppercase tracking-widest">Support</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/faq')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">Help Center</button></li>
              <li><button onClick={() => navigate('/contact')} className="text-gray-600 hover:text-rose-500 font-medium text-sm transition-colors">Contact Support</button></li>
            </ul>
          </div>
        </div>

        {/* Footer Subtle Text */}
        <div className="pt-12 flex items-center justify-center gap-6 opacity-40">
           <p className="text-xs font-medium text-gray-400 flex items-center gap-1.5">
             <Search size={14} /> Ref ID: {Math.random().toString(36).substr(2, 9).toUpperCase()}
           </p>
           <div className="w-1 h-1 rounded-full bg-gray-300" />
           <p className="text-xs font-medium text-gray-400">Error 404: Not Found</p>
        </div>

      </div>
    </main>
  );
}
